import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "../../lib/api";
import { Link } from "react-router-dom";
import { Input } from "../ui/input";
import { MagnifyingGlass, Sparkle } from "@phosphor-icons/react";
import { ActionQueue, FunnelCard, ComplianceShield, OpportunityEngine } from "./FlightDeckPanels";
import { ServiceRequestInbox } from "./ServiceRequestInbox";
import { ServiceInboxPulse } from "./ServiceInboxPulse";
import { CopilotTray } from "./CopilotTray";

export function FlightDeck() {
  const [q, setQ] = useState("");
  const [copilotOpen, setCopilotOpen] = useState(false);
  const [prefill, setPrefill] = useState("");
  const { data } = useQuery({ queryKey: ["flightdeck"], queryFn: () => api.get("/flightdeck").then((r) => r.data), refetchInterval: 60000, refetchIntervalInBackground: false });
  const { data: clients } = useQuery({ queryKey: ["clients-list"], queryFn: () => api.get("/clients").then((r) => r.data) });
  const matches = q.trim() ? (clients || []).filter((c) => c.name.toLowerCase().includes(q.toLowerCase())).slice(0, 5) : [];

  const askCopilot = () => { setPrefill(q.trim()); setCopilotOpen(true); setQ(""); };

  return (
    <div data-testid="flight-deck" className="space-y-4">
      <div className="relative">
        <div className="flex items-center gap-2">
          <div className="relative flex-1">
            <MagnifyingGlass size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
            <Input data-testid="flightdeck-search" placeholder="Search client, form, or query the co-pilot across your portfolio…"
              value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && q.trim() && askCopilot()}
              className="pl-9 h-10 bg-white" />
          </div>
          <button data-testid="copilot-open-btn" onClick={() => { setPrefill(""); setCopilotOpen(true); }}
            className="flex items-center gap-1.5 h-10 px-4 rounded-md bg-zinc-900 text-white text-xs hover:bg-zinc-700 transition-colors duration-150">
            <Sparkle size={14} /> Co-pilot
          </button>
        </div>
        {(matches.length > 0 || q.trim()) && (
          <div className="absolute z-20 mt-1 w-full rounded-md border border-zinc-200 bg-white shadow-lg py-1" data-testid="flightdeck-search-results">
            {matches.map((c) => (
              <Link key={c.id} to={`/clients/${c.id}`} data-testid={`search-client-${c.id}`} onClick={() => setQ("")}
                className="block px-3 py-1.5 text-xs text-zinc-700 hover:bg-zinc-50">
                {c.name} <span className="text-zinc-400">· {c.entity_type}</span>
              </Link>
            ))}
            {q.trim() && (
              <button data-testid="search-ask-copilot" onClick={askCopilot} className="w-full text-left px-3 py-1.5 text-xs text-indigo-700 hover:bg-indigo-50 flex items-center gap-1.5">
                <Sparkle size={12} /> Ask co-pilot: "{q.trim()}"
              </button>
            )}
          </div>
        )}
      </div>

      {data && (
        <>
          <ServiceInboxPulse requests={data.service_requests || []} />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <ActionQueue q={data.action_queue} />
            <FunnelCard f={data.funnel} />
            <ComplianceShield s={data.compliance_shield} />
            <OpportunityEngine opportunities={data.opportunities} />
            <ServiceRequestInbox requests={data.service_requests || []} />
          </div>
        </>
      )}

      <CopilotTray open={copilotOpen} onOpenChange={setCopilotOpen} prefill={prefill} />
    </div>
  );
}
